import React, { useState, useEffect } from "react";
import { LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { HiOutlineArrowRight } from "react-icons/hi";
import Table from "../../common/Table";
import Loader from "../../common/Loader";
import Button from "../../common/Button";
import { DiePurchaseOrderAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import { formatDate } from "../../utlis/formateDate";
import DieInwardModal from "./DieInwardModal";

const PendingInwardTab = ({ selectedItems, setSelectedItems, isInwardModalOpen, setIsInwardModalOpen }) => {
    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await DiePurchaseOrderAPI.getPendingInwardItems();
            if (res?.success) {
                setDataList(res.data || []);
            }
        } catch (error) {
            notify("Error fetching pending items", "error");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleInwardSuccess = () => {
        setIsInwardModalOpen(false);
        setSelectedItems([]);
        fetchData();
    };

    const columns = [
        { key: "pO_No", label: "PO #" },
        { key: "pO_Date", label: "PO Date", render: (val) => formatDate(val) },
        { key: "supplier_Name", label: "Supplier" },
        { key: "dieNumber", label: "Die Number" },
        { key: "subDieNo", label: "Sub Die#" },
        { key: "profile_Name", label: "Profile Name" },
        { key: "series_Name", label: "Series" },
        { key: "width_Height", label: "W * H" },
        { key: "orderWeight", label: "Order Wt" },
    ];

    const filteredData = dataList.filter(item =>
        !searchTerm ||
        item.dieNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pO_No?.toString().includes(searchTerm) ||
        item.supplier_Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="flex flex-col h-full bg-white font-plus">
            {/* Action Bar - Standardized Spacing */}

            {/* Content Table Container */}
            <div className="flex-1 overflow-auto border border-gray-200 bg-white relative">
                {loading && <Loader centered />}
                <Table
                        columns={columns}
                        data={filteredData}
                        showActions={false}
                        checkbox={{
                            idField: "trn_No",
                            selected: selectedItems,
                            onToggle: (id, checked) => {
                                if (checked) {
                                    setSelectedItems(prev => [...prev, id]);
                                } else {
                                    setSelectedItems(prev => prev.filter(x => x !== id));
                                }
                            },
                            onToggleAll: (ids, checked) => {
                                if (checked) {
                                    setSelectedItems(ids);
                                } else {
                                    setSelectedItems([]);
                                }
                            }
                        }}
                        rowIdField="trn_No"
                        tableClassName="text-[12px] font-bold"
                    />
            </div>

            {isInwardModalOpen && (
                <DieInwardModal
                    selectedItems={dataList.filter(item => selectedItems.includes(item.trn_No))}
                    onClose={() => setIsInwardModalOpen(false)}
                    onSuccess={handleInwardSuccess}
                />
            )}
        </div>
    );
};


export default PendingInwardTab;
